import React, { useState } from 'react';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import styled from 'styled-components';
import IconVideo from '@catalogo/ui-americanas-desktop-svg/icon-video.svg';

export const eventSetShowVideo = setShowVideo => () => setShowVideo(true);

export const Video = ({ image, alt }) => {
  const [showVideo, setShowVideo] = useState(false);

  if (showVideo) {
    return (
      <Container>
        <iframe src={image.video} width="400px" height="400px" allowFullScreen allow="autoplay" />
      </Container>
    );
  }

  return (
    <Container>
      <IconPlay fill="#999" onClick={eventSetShowVideo(setShowVideo)} />
      <LazyPicture sources={{ desktop: { src: image.main, ratio: '1:1' } }} alt={alt} />
    </Container>
  );
};

export const IconPlay = styled(IconVideo)`
  width: 30%;
  height: 30%;
  color: white;
  cursor: pointer;
  position: absolute;
  z-index: 10;

  :hover {
    fill: ${({ theme }) => theme.primaryColor};
    transition: 0.4s all;
  }
`;

const Container = styled.div`
  width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export default Video;
